import { EntityTypes, Geotab, SearchTypes } from "@fairfleet/geotab";
import { O } from "ts-toolbelt";

const DEFAULT_PAGE_SIZE = 50_000;

export async function paginatedFeed<
  TType extends keyof EntityTypes & keyof SearchTypes,
  TEntity = EntityTypes[TType],
  TSearch extends object = SearchTypes[TType],
>(
  geotabClient: Geotab,
  typeName: TType,
  search: O.Partial<TSearch>,
  pageSize: number = DEFAULT_PAGE_SIZE,
  signal?: AbortSignal,
): Promise<TEntity[]> {
  const out: TEntity[] = [];
  let fromVersion: string | undefined;

  while (true) {
    signal?.throwIfAborted();
    const res = await geotabClient.getFeed<TType, TEntity, TSearch>(
      typeName,
      search,
      fromVersion,
      pageSize,
      signal,
    );
    out.push(...res.data);
    if (res.data.length < pageSize) {
      return out;
    }
    if (res.toVersion === fromVersion) {
      // Server returned a full page without advancing the cursor; treat as exhausted to avoid an infinite loop.
      return out;
    }
    fromVersion = res.toVersion;
  }
}
